import { a as q, A as J, b as K, D as X, d as Y } from "./index-d695019d.mjs";
import { Accordion as oo, AccordionItem as ro, AccordionPanel as eo } from "./accordion.js";
import { AspectRatio as ao } from "./aspectRatio.js";
import { AvatarNew as no } from "./avatar.js";
import { Badge as so } from "./badge.js";
import { BarChart as lo } from "./barChart.js";
import { BlogVideo as co } from "./blogVideo.js";
import { Breadcrumb as fo, BreadcrumbItem as ho } from "./breadcrumb.js";
import { Button as Co } from "./button.js";
import { ButtonGroup as Io } from "./buttonGroup.js";
import { ButtonV1 as yo } from "./buttonV1.js";
import { Card as Po } from "./card.js";
import { CardIllustration as m } from "./cardIllustration.js";
import { jsxs as x, jsx as e } from "react/jsx-runtime";
import { c as p } from "./index-65016bfa.mjs";
import t, { css as a } from "styled-components";
import { fpds as r } from "@fcamna/shared-component-foundations";
import "react";
import { u as f } from "./useQuantum-50e8fd44.mjs";
import { R as vo, T as Lo, g as Do, i as Mo, a as Ao } from "./isClient-ec947a14.mjs";
import { b as d } from "./useSlots-a1aa6a84.mjs";
import { U as Bo, f as Go, o as Ho, u as wo, c as Vo, d as zo, a as Oo, e as Ro } from "./useSlots-a1aa6a84.mjs";
import { FeatureText as h } from "./featureText.js";
import { RaisedSurface as s } from "./raisedSurface.js";
import { c as S } from "./childrenCountCheck-785fa19a.mjs";
import "./setup-0f23222d.mjs";
import { TableContext as $o, TableProvider as Uo } from "./table.js";
import "./uniqueId-321287e8.mjs";
import { Checkbox as Eo, CheckboxList as Wo, CheckboxStateValues as jo } from "./checkbox.js";
import { Chip as qo, ChipGroup as Jo } from "./chip.js";
import { CloseButton as Xo } from "./closeButton.js";
import { ColumnChart as Zo } from "./columnChart.js";
import { CreditCardInput as rr } from "./creditCardInput.js";
import { CTAButton as tr } from "./ctaButton.js";
import { CurrencyInput as ir } from "./currencyInput.js";
import { DataList as pr } from "./dataList.js";
import { DatePicker as mr } from "./datePicker.js";
import { Disclosures as ur } from "./disclosure.js";
import { Divider as xr, DividerLayout as fr, DividerThickness as dr } from "./divider.js";
import { DonutChart as Sr } from "./donutChart.js";
import { Drawer as Tr, DrawerContent as Ir, DrawerFooter as gr, DrawerHeader as yr } from "./drawer.js";
import { DropdownMenu as Pr } from "./dropdownMenu.js";
import { D as vr } from "./index-2be68378.mjs";
import { FileProgress as Dr, FileUpload as Mr, FileUploadProvider as Ar, UPLOAD_STATUS as Fr, useFileUploadContext as Br } from "./fileUpload.js";
import { Filter as Hr, FilterGroup as wr, FiltersContainer as Vr, StyledChipGroupContainer as zr, StyledFilterContainer as Or, StyledFilterGroup as Rr, StyledTableFilterGroup as Nr } from "./filter.js";
import { FocusTrap as Ur, FocusTrapNavigationType as _r } from "./focusTrap.js";
import { GlobalAttributeBar as Wr } from "./globalAttributeBar.js";
import { Grid as Qr } from "./grid.js";
import { HeatMapChart as Jr } from "./heatMapChart.js";
import { HeroVideo as Xr } from "./heroVideo.js";
import { Hero as Zr, HeroContentAlignment as oe, HeroVideoV1 as re } from "./hero.js";
import { Icon as te, IconColor as ae, Icons as ie } from "./icon.js";
import { IconButton as pe } from "./iconButton.js";
import { Image as me } from "./image.js";
import { DecrementStepper as ue, IncrementSelector as ce, IncrementStepper as xe, NumberInputField as fe } from "./incrementSelector.js";
import { InLineAlert as he } from "./inLineAlert.js";
import { InLineText as Ce } from "./inLineText.js";
import { A as Ie, C as ge } from "./carousel-c5108cdc.mjs";
import { I as be } from "./helperText-d9646f54.mjs";
import { L as ke } from "./label-33699561.mjs";
import { JumpLink as Le } from "./jumpLink.js";
import { LandingHeroVideo as Me } from "./landingHeroVideo.js";
import { LandingHeroVideoV1 as Fe } from "./landingHeroVideoV1.js";
import { LandingPageVideo as Ge } from "./landingPageVideo.js";
import { Link as we } from "./link.js";
import { List as ze, ListIcon as Oe, ListItem as Re } from "./list.js";
import { MarketingComparisonTable as $e } from "./marketingComparisonTable.js";
import { MarketingDataList as _e } from "./marketingDataList.js";
import { MarketingList as We } from "./marketingList.js";
import { MediaDisclosureButton as Qe } from "./mediaDisclosureButton.js";
import { MegaMenu as Je } from "./megaMenu.js";
import { Ellipses as Xe, Menu as Ye, MenuItem as Ze } from "./menu.js";
import { ModalVideo as rt } from "./modalVideo.js";
import { ModalBody as tt, ModalFooter as at, ModalHeader as it, ModalWindow as nt } from "./modalWindow.js";
import { PageHeader as st } from "./pageHeader.js";
import { Pagination as lt } from "./pagination.js";
import { PhoneInput as ct } from "./phoneInput.js";
import { PhotoGallery as ft } from "./photoGallery.js";
import { PhotoGalleryThumbnail as ht } from "./photoGalleryThumbnail.js";
import { PhotoGalleryLightbox as Ct } from "./photoGalleryLightbox.js";
import { PopupPlacement as It, PopupTip as gt, PopupTipLinks as yt, getPosition as bt } from "./popupTip.js";
import { ProgressBar as kt } from "./progressBar.js";
import { ProgressTracker as Lt } from "./progressTracker.js";
import { ProgressTrackerVertical as Mt } from "./progressTrackerVertical.js";
import { Radio as Ft, RadioList as Bt } from "./radio.js";
import { ReadOnlySection as Ht } from "./readOnlySection.js";
import { ScatterPlotChart as Vt } from "./scatterPlotChart.js";
import { Search as Ot } from "./search.js";
import { SearchInputLocation as Nt } from "./searchInputLocation.js";
import { SegmentControl as Ut } from "./segmentControl.js";
import { MultiSelectInput as Et, SingleSelectInput as Wt } from "./multiSelectInput.js";
import { SelectionCard as Qt, SelectionTileCompactGroup as qt } from "./selectionCard.js";
import { ShareLinks as Kt } from "./shareLinks.js";
import { ShowMoreLess as Yt } from "./showMoreLess.js";
import { Skeleton as oa } from "./skeleton.js";
import { Slider as ea } from "./slider.js";
import { Slot as aa } from "./slot.js";
import { SnackbarProvider as na, SnackbarStory as pa, useSnackbars as sa } from "./snackbar.js";
import { Spinner as la } from "./spinner.js";
import { Switch as ca } from "./switch.js";
import { Indicator as fa, Tab as da, TabList as ha, TabPanel as Sa, TabPanels as Ca, Tabs as Ta } from "./tabs.js";
import { Tag as ga, TagsGroup as ya } from "./tags.js";
import { A as Pa, Caption as ka, Display1 as va, Display2 as La, Display3 as Da, DisplayTypoGraphy as Ma, H1 as Aa, H2 as Fa, H3 as Ba, H4 as Ga, H5 as Ha, H6 as wa, HeadingTypoGraphy as Va, Li as za, Ol as Oa, P as Ra, StyledTable as Na, SubTitle as $a, Table as Ua, Text as _a, Title as Ea, Typography as Wa, Ul as ja } from "./text.js";
import { TextArea as qa } from "./textArea.js";
import { TextDisclosure as Ka } from "./textDisclosure.js";
import { TextInput as Ya } from "./textInput.js";
import { TimePickerInput as oi } from "./timePickerInput.js";
import { Tooltip as ei } from "./tooltip.js";
import { TopBanner as ai } from "./topBanner.js";
import { useTheme as ni } from "./useTheme.js";
import { u as si } from "./useAccessibilityProps-2f24cf29.mjs";
import { u as li } from "./useAEMEditorComponentSize-4d8ec5ae.mjs";
import { u as ci } from "./useWindowDimensions-ae69e913.mjs";
import { VideoPlayer as fi } from "./videoPlayer.js";
import { u as hi } from "./usePopoverIndex-b3a93ecd.mjs";
import { u as Ci } from "./useClient-0bbce34e.mjs";
import { useFocusTrap as Ii, useLocalStorage as gi, useMutationObserver as yi, useOnClickOutside as bi, useSessionStorage as Pi, useStorage as ki } from "./hooks.js";
import { u as Li } from "./useMediaQuery-2533ee8a.mjs";
import { u as Mi } from "./useSize-a56c9e53.mjs";
import { u as Fi } from "./useWindowSize-88e90e04.mjs";
import { b as Gi, g as Hi, a as wi } from "./Aria-f5e019e2.mjs";
import { c as zi } from "./cloneSlots-333ddef1.mjs";
import { c as Ri } from "./combineRefs-90f27925.mjs";
import "@fcamna/shared-icons";
import "./tableContainer-b8b41f9e.mjs";
import "./index-5d51183d.mjs";
import "./tslib.es6-59e1c9d8.mjs";
import "./useChartOptions-336145ca.mjs";
import "./hTag-27bb1617.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
import "./screenReaderOnly-fd82ed96.mjs";
import "./getElementPosition-a8642645.mjs";
const C = t.div`
  &.CardIllustrationSection {
    ${({
  theme: {
    components: { cardIllustrationSection: o }
  }
}) => a(o.CardIllustrationSectionWrapper)};
  }
`, T = t.div`
  &.CardIllustrationGroup__FeatureTextContainer {
    ${({
  theme: {
    components: { cardIllustrationSection: o }
  }
}) => a(o.FeatureTextContainer)};
  }
`, I = t.div`
  &.CardIllustrationGroup {
    ${({
  theme: {
    components: { cardIllustrationSection: o }
  }
}) => a(o.CardIllustrationGroup)};
  }
`, g = ({ featureTextProps: o, enableRaisedSurface: l = !0, children: i }) => {
  const u = d(i, { card: m }), c = f({ label: "Card Illustration Section" });
  S({
    additionalInfo: "Maximum card count exceeded. Max 6 cards are allowed in a Card Illustration Section.",
    children: i,
    componentName: "Card Illustration Section",
    maxChildren: 6
  });
  const n = /* @__PURE__ */ x(
    C,
    {
      className: p(["CardIllustrationSection"]),
      ...c,
      children: [
        o && /* @__PURE__ */ e(T, { className: p(["CardIllustrationSection__FeatureTextContainer"]), children: /* @__PURE__ */ e(
          h,
          {
            ...o,
            alignment: "center"
          }
        ) }),
        /* @__PURE__ */ e(I, { className: "CardIllustrationGroup", children: u.card })
      ]
    }
  );
  return l ? /* @__PURE__ */ e(s, { children: /* @__PURE__ */ e(s.Container, { children: n }) }) : n;
};
g.Card = m;
const W = () => `
//*****Superscript styles*****
  sup {
    line-height: 0;
    font-size: inherit;
    a {
      font-size: 75% !important;
      text-decoration: none;
    }
    a:hover,
    a:active {
      text-underline-offset: 2px;
      text-decoration: underline;
    }
    a.disclosure-superscript-link {
      font-size: 75% !important;
      text-underline-offset: 2px !important;
      color: ${r.semantic.color.link.default};
      // focus style for <sup> tag under heading text
      outline-offset: 1px !important;
      border-radius: 2px !important;
    }
    a:visited,
    a.disclosure-superscript-link:visited {
      color: ${r.semantic.color.link.visited};
      text-decoration: none;
    }
    a:hover,
    a.disclosure-superscript-link:hover {
      color: ${r.semantic.color.link.hover};
      text-decoration: underline;
      text-decoration-color: ${r.semantic.color.link.hover};
    }
    a:active,
    a.disclosure-superscript-link:active {
      color: ${r.semantic.color.link.active};
      text-decoration: underline;
      text-decoration-color: ${r.semantic.color.link.active};
    }
  }
  sup:not(:has(a)) {
    font-size: 75%;
  }
  /* For <sup> tag under heading text */
  h1 sup,
  h2 sup,
  h3 sup,
  h4 sup,
  h5 sup,
  h6 sup {
    font-size: inherit;
    a {
      font-size: 50% !important;
      text-decoration: none;
    }
    a:hover {
      text-underline-offset: 2px;
      text-decoration: underline;
    }
    a,
    a.disclosure-superscript-link {
      font-size: 50% !important;
      text-underline-offset: 2px !important;
    }
  }
  h1 sup:not(:has(a)),
  h2 sup:not(:has(a)),
  h3 sup:not(:has(a)),
  h4 sup:not(:has(a)),
  h5 sup:not(:has(a)),
  h6 sup:not(:has(a)) {
    font-size: 50%;
  }
  //*****Superscript styles*****
`;
export {
  Pa as A,
  oo as Accordion,
  ro as AccordionItem,
  q as AccordionItemOld,
  J as AccordionOld,
  eo as AccordionPanel,
  K as AccordionPanelOld,
  Ie as ActionBar,
  ao as AspectRatio,
  no as AvatarNew,
  so as Badge,
  lo as BarChart,
  co as BlogVideo,
  fo as Breadcrumb,
  ho as BreadcrumbItem,
  Co as Button,
  Io as ButtonGroup,
  yo as ButtonV1,
  tr as CTAButton,
  ka as Caption,
  Po as Card,
  m as CardIllustration,
  g as CardIllustrationSection,
  ge as Carousel,
  Eo as Checkbox,
  Wo as CheckboxList,
  jo as CheckboxStateValues,
  qo as Chip,
  Jo as ChipGroup,
  Xo as CloseButton,
  Zo as ColumnChart,
  rr as CreditCardInput,
  ir as CurrencyInput,
  pr as DataList,
  X as DataTable,
  mr as DatePicker,
  ue as DecrementStepper,
  ur as Disclosures,
  va as Display1,
  La as Display2,
  Da as Display3,
  Ma as DisplayTypoGraphy,
  xr as Divider,
  fr as DividerLayout,
  dr as DividerThickness,
  Sr as DonutChart,
  Tr as Drawer,
  Ir as DrawerContent,
  gr as DrawerFooter,
  yr as DrawerHeader,
  Pr as DropdownMenu,
  vr as DropdownMenuBase,
  Xe as Ellipses,
  h as FeatureText,
  Dr as FileProgress,
  Mr as FileUpload,
  Ar as FileUploadProvider,
  Hr as Filter,
  wr as FilterGroup,
  Vr as FiltersContainer,
  Ur as FocusTrap,
  _r as FocusTrapNavigationType,
  Wr as GlobalAttributeBar,
  Qr as Grid,
  Aa as H1,
  Fa as H2,
  Ba as H3,
  Ga as H4,
  Ha as H5,
  wa as H6,
  Va as HeadingTypoGraphy,
  Jr as HeatMapChart,
  Zr as Hero,
  oe as HeroContentAlignment,
  Xr as HeroVideo,
  re as HeroVideoV1,
  te as Icon,
  pe as IconButton,
  ae as IconColor,
  ie as Icons,
  me as Image,
  he as InLineAlert,
  Ce as InLineText,
  ce as IncrementSelector,
  xe as IncrementStepper,
  fa as Indicator,
  be as InputState,
  Le as JumpLink,
  ke as Label,
  Me as LandingHeroVideo,
  Fe as LandingHeroVideoV1,
  Ge as LandingPageVideo,
  za as Li,
  we as Link,
  ze as List,
  Oe as ListIcon,
  Re as ListItem,
  $e as MarketingComparisonTable,
  _e as MarketingDataList,
  We as MarketingList,
  Qe as MediaDisclosureButton,
  Je as MegaMenu,
  Ye as Menu,
  Ze as MenuItem,
  tt as ModalBody,
  at as ModalFooter,
  it as ModalHeader,
  rt as ModalVideo,
  nt as ModalWindow,
  Et as MultiSelectInput,
  fe as NumberInputField,
  Oa as Ol,
  Ra as P,
  st as PageHeader,
  lt as Pagination,
  ct as PhoneInput,
  ft as PhotoGallery,
  Ct as PhotoGalleryLightbox,
  ht as PhotoGalleryThumbnail,
  It as PopupPlacement,
  gt as PopupTip,
  yt as PopupTipLinks,
  kt as ProgressBar,
  Lt as ProgressTracker,
  Mt as ProgressTrackerVertical,
  Ft as Radio,
  Bt as RadioList,
  s as RaisedSurface,
  Ht as ReadOnlySection,
  vo as RoleToAriaKeysMap,
  Vt as ScatterPlotChart,
  Ot as Search,
  Nt as SearchInputLocation,
  Ut as SegmentControl,
  Qt as SelectionCard,
  qt as SelectionTileCompactGroup,
  Kt as ShareLinks,
  Yt as ShowMoreLess,
  Wt as SingleSelectInput,
  oa as Skeleton,
  ea as Slider,
  aa as Slot,
  na as SnackbarProvider,
  pa as SnackbarStory,
  la as Spinner,
  zr as StyledChipGroupContainer,
  Or as StyledFilterContainer,
  Rr as StyledFilterGroup,
  Na as StyledTable,
  Nr as StyledTableFilterGroup,
  $a as SubTitle,
  ca as Switch,
  da as Tab,
  ha as TabList,
  Sa as TabPanel,
  Ca as TabPanels,
  Ua as Table,
  $o as TableContext,
  Uo as TableProvider,
  Ta as Tabs,
  ga as Tag,
  Lo as TagNameToRoleMap,
  ya as TagsGroup,
  _a as Text,
  qa as TextArea,
  Ka as TextDisclosure,
  Ya as TextInput,
  oi as TimePickerInput,
  Ea as Title,
  ei as Tooltip,
  ai as TopBanner,
  Wa as Typography,
  Fr as UPLOAD_STATUS,
  ja as Ul,
  Bo as UseSlotsPickType,
  fi as VideoPlayer,
  W as applySuperScriptStyles,
  zi as cloneSlots,
  Ri as combineRefs,
  Go as createSlots,
  Y as debounce,
  Gi as getAriaProps,
  Hi as getAriaPropsByRole,
  wi as getAriaPropsByTagName,
  bt as getPosition,
  Do as getTarget,
  Mo as isApiSupported,
  Ao as isClient,
  Ho as overflownDefaults,
  li as useAEMEditorComponentSize,
  si as useAccessibilityProps,
  Ci as useClient,
  wo as useEventListener,
  Br as useFileUploadContext,
  Ii as useFocusTrap,
  Vo as useIsMounted,
  gi as useLocalStorage,
  Li as useMediaQuery,
  yi as useMutationObserver,
  bi as useOnClickOutside,
  zo as useOverFlown,
  hi as usePopoverIndex,
  f as useQuantum,
  Oo as useResizeObserver,
  Ro as useScroll,
  Pi as useSessionStorage,
  Mi as useSize,
  d as useSlots,
  sa as useSnackbars,
  ki as useStorage,
  ni as useTheme,
  ci as useWindowDimensions,
  Fi as useWindowSize
};
